<template>
  <form
    ref="status_form"
    class="space-y-4"
    @submit.prevent
    @reset="
      keyword = undefined;
      path = undefined;
      extension = undefined;
      min_size = undefined;
      max_size = undefined;
    "
  >
    <div class="space-y-2">
      <div>
        <legend>Tên tệp tin/thư mục</legend>
        <label class="input w-full">
          <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
          <input
            type="text"
            placeholder="Nhập tên tệp tin/thư mục"
            name="keyword"
            v-model="keyword"
            :disabled="explorer_store.loading.get_files"
          />
        </label>
      </div>
      <div>
        <legend>Định dạng tệp tin</legend>
        <label class="input w-full">
          <i class="fa-solid fa-filter text-base-content/80"></i>
          <input
            type="text"
            placeholder="Tất cả định dạng"
            name="extension"
            list="extension-options"
            autocomplete="off"
            v-model="extension"
            :disabled="explorer_store.loading.get_files"
          />
        </label>
        <datalist id="extension-options">
          <option
            v-for="ext in explorer_store.extensions"
            :key="ext.key"
            :value="ext.key"
          >
            {{ ext.doc_count }}
          </option>
        </datalist>
      </div>
      <div>
        <legend>Kích thước tối thiểu (byte)</legend>
        <label class="input w-full">
          <input
            type="number"
            min="0"
            step="1"
            placeholder="Không giới hạn"
            name="min_size"
            v-model="min_size"
            :disabled="explorer_store.loading.get_files"
          />
        </label>
      </div>
      <div>
        <legend>Kích thước tối đa (byte)</legend>
        <label class="input w-full">
          <input
            type="number"
            min="0"
            step="1"
            placeholder="Không giới hạn"
            name="max_size"
            v-model="max_size"
            :disabled="explorer_store.loading.get_files"
          />
        </label>
      </div>
      <p v-if="invalid_size_range" class="text-error" role="alert">
        Kích thước tối thiểu không được lớn hơn kích thước tối đa.
      </p>
      <div>
        <legend>Đường dẫn</legend>
        <label class="input w-full">
          <input
            type="text"
            placeholder="Thư mục hiện tại"
            name="keyword"
            disabled
            v-model="path"
          />
        </label>
      </div>
    </div>
    <div class="flex flex-wrap gap-2">
      <input
        class="btn btn-outline grow"
        type="reset"
        value="&#8635; Đặt lại"
        :disabled="explorer_store.loading.get_files"
      />
    </div>
  </form>
</template>
<script setup lang="ts">
import { str_from_query } from "@/api";
import { router } from "@/router/router";
import { watchDebounced } from "@vueuse/core";
import { computed, ref, watch } from "vue";
import { use_explorer } from "./useExplorer";

const explorer_store = use_explorer();

const init_keyword = computed(() => str_from_query("keyword"));
const keyword = ref<string | undefined>(str_from_query("keyword"));
const init_path = computed(() => str_from_query("path"));
const path = ref<string | undefined>(str_from_query("path"));
const init_extension = computed(() => str_from_query("extension"));
const extension = ref<string | undefined>(str_from_query("extension"));
const init_min_size = computed(() => str_from_query("min_size"));
const min_size = ref<string | undefined>(init_min_size.value);
const init_max_size = computed(() => str_from_query("max_size"));
const max_size = ref<string | undefined>(init_max_size.value);
const invalid_size_range = computed(() => {
  const min = min_size.value ? Number(min_size.value) : undefined;
  const max = max_size.value ? Number(max_size.value) : undefined;
  return (min !== undefined && (!Number.isSafeInteger(min) || min < 0)) || (max !== undefined && (!Number.isSafeInteger(max) || max < 0)) || (min !== undefined && max !== undefined && min > max);
});

const update_route = () => {
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      keyword: keyword.value,
      path: path.value,
      extension: extension.value,
      min_size: min_size.value || undefined,
      max_size: max_size.value || undefined,
    },
  });
};

watchDebounced(
  [keyword, path, extension, min_size, max_size],
  () => {
    if (invalid_size_range.value) return;
    if (
      keyword.value !== init_keyword.value ||
      path.value !== init_path.value ||
      extension.value !== init_extension.value ||
      min_size.value !== init_min_size.value ||
      max_size.value !== init_max_size.value
    ) {
      update_route();
    }
  },
  { debounce: 500, maxWait: 1000 },
);

watch(
  () => [init_path.value],
  () => {
    path.value = init_path.value;
    // When URL path changes, we update local path.
    // We do NOT want to trigger update_route here because it would be a loop or redundant.
    // But update_route pushes to router.
  },
);

// Also sync keyword from URL if it changes externally
watch(init_keyword, () => {
  if (keyword.value !== init_keyword.value) {
    keyword.value = init_keyword.value;
  }
});

// Also sync extension from URL if it changes externally
watch(init_extension, () => {
  if (extension.value !== init_extension.value) {
    extension.value = init_extension.value;
  }
});
watch(init_min_size, () => { min_size.value = init_min_size.value; });
watch(init_max_size, () => { max_size.value = init_max_size.value; });
</script>
